export default __webpack_public_path__ + "media/vue.48936141.png";